import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPatients = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24.153,
	height: 14.654,
	viewBox: "0 0 24.153 14.654",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		id: "Group_2672",
		"data-name": "Group 2672",
		transform: "translate(-40.995 -141.372)",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group_364",
			"data-name": "Group 364",
			transform: "translate(41.977 142.271)",
			children: [
				/* @__PURE__ */ _jsxs("g", {
					id: "Group_361",
					"data-name": "Group 361",
					transform: "translate(5.491)",
					children: [/* @__PURE__ */ _jsx("path", {
						id: "Ellipse_123",
						"data-name": "Ellipse 123",
						d: "M3.274-.9A4.174,4.174,0,1,1-.9,3.274,4.179,4.179,0,0,1,3.274-.9Zm0,6.548A2.374,2.374,0,1,0,.9,3.274,2.377,2.377,0,0,0,3.274,5.648Z",
						transform: "translate(2.419 0)",
						fill: "current"
					}), /* @__PURE__ */ _jsx("path", {
						id: "Path_382",
						"data-name": "Path 382",
						d: "M2967.882,1666.495a8.64,8.64,0,0,1-6.308-2.727l-.327-.347.1-.465a4.5,4.5,0,0,1,4.388-3.515h4.367a4.485,4.485,0,0,1,4.368,3.428l.114.468-.326.355A8.685,8.685,0,0,1,2967.882,1666.495Zm-4.631-3.6a6.788,6.788,0,0,0,4.631,1.8,6.882,6.882,0,0,0,4.689-1.853,2.69,2.69,0,0,0-2.466-1.6h-4.367A2.717,2.717,0,0,0,2963.251,1662.9Z",
						transform: "translate(-2962.229 -1652.741)",
						fill: "current"
					})]
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "Group_362",
					"data-name": "Group 362",
					transform: "translate(15.378 1.542)",
					children: [/* @__PURE__ */ _jsx("path", {
						id: "Ellipse_124",
						"data-name": "Ellipse 124",
						d: "M2.488-.9A3.388,3.388,0,1,1-.9,2.488,3.392,3.392,0,0,1,2.488-.9Zm0,4.977A1.588,1.588,0,1,0,.9,2.488,1.59,1.59,0,0,0,2.488,4.077Z",
						transform: "translate(0 0)",
						fill: "current"
					}), /* @__PURE__ */ _jsx("path", {
						id: "Path_383",
						"data-name": "Path 383",
						d: "M3026.382,1663.592a.9.9,0,0,1,0-1.8,5.015,5.015,0,0,0,3.3-1.243,1.829,1.829,0,0,0-1.608-.95h-3.319a.9.9,0,0,1,0-1.8h3.319a3.624,3.624,0,0,1,3.53,2.77l.114.468-.326.355A6.819,6.819,0,0,1,3026.382,1663.592Z",
						transform: "translate(-3023.924 -1652.923)",
						fill: "current"
					})]
				}),
				/* @__PURE__ */ _jsxs("g", {
					id: "Group_363",
					"data-name": "Group 363",
					transform: "translate(0 1.542)",
					children: [/* @__PURE__ */ _jsx("path", {
						id: "Ellipse_125",
						"data-name": "Ellipse 125",
						d: "M2.488-.9A3.388,3.388,0,1,1-.9,2.488,3.392,3.392,0,0,1,2.488-.9Zm0,4.977A1.588,1.588,0,1,0,.9,2.488,1.59,1.59,0,0,0,2.488,4.077Z",
						transform: "translate(1.839 0)",
						fill: "current"
					}), /* @__PURE__ */ _jsx("path", {
						id: "Path_384",
						"data-name": "Path 384",
						d: "M2934.486,1663.592a6.826,6.826,0,0,1-4.952-2.141l-.327-.347.1-.465a3.634,3.634,0,0,1,3.546-2.84h3.319a.9.9,0,0,1,0,1.8h-3.319a1.848,1.848,0,0,0-1.626.989,4.944,4.944,0,0,0,3.255,1.2.9.9,0,0,1,0,1.8Z",
						transform: "translate(-2930.19 -1652.923)",
						fill: "current"
					})]
				})
			]
		})
	})]
});
const ForwardRef = forwardRef(SvgPatients);
export { ForwardRef as ReactComponent };
